import { useContext, useEffect } from "react";
import { Flex, Text, CloseButton, Center } from "@chakra-ui/react";

// Constants
import { BANNER_CTA, CLOSE_BANNER, VIEW_BANNER } from "constants/analytics";

// Contexts
import { StakeContext } from "providers/StakeProvider";

type Props = {
  text: string;
  link: string;
  ctaText: string;
  closeBanner: () => void;
};

const Banner = ({ text, link, ctaText, closeBanner }: Props) => {
  const { track } = useContext(StakeContext);

  useEffect(() => {
    track(VIEW_BANNER);
  }, []);

  return (
    <Flex
      // p="0.5rem"
      w="100%"
      bg="brand.primary"
      textColor="brand.textLight"
      fontFamily="medium"
      alignItems="center"
      pos={{ base: "relative", lg: "sticky" }}
      top="0"
      zIndex={4}
    >
      <Center flexGrow={1} flexDir={{ base: "column", lg: "row" }}>
        <Text textAlign="center" ml="0.5rem">
          <Text as="span" mr="0.5rem" fontSize={{ base: 12, xl: 14 }}>
            {text}{" "}
          </Text>
        </Text>
        {link && ctaText && (
          <Text
            as="a"
            href={link}
            target="_blank"
            rel="noreferrer"
            p="0.25rem"
            fontSize={{ base: 12, xl: 14 }}
            color="white"
            textDecor="underline !important"
            cursor="pointer"
            onClick={() => track(BANNER_CTA)}
          >
            {ctaText}
          </Text>
        )}
      </Center>

      <CloseButton
        onClick={() => {
          track(CLOSE_BANNER);
          closeBanner();
        }}
      />
    </Flex>
  );
};

export default Banner;
